import { render, staticRenderFns } from "./NotificationsLog.vue?vue&type=template&id=09123a8a"
import script from "./NotificationsLog.vue?vue&type=script&lang=js"
export * from "./NotificationsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports